import styled from "styled-components";

export const AmusnetWidgetWrapperDefaultBox = styled.div`
    border-radius: 10px;
    border: 1px solid transparent;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, 
        rgba(255, 255, 255, 0.4) 100%) border-box;
    box-shadow: 0px 0px 5px 0px #FFFFFF4D,
        0px 0px 26px 10px #FFFFFF1A inset;
`;